import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { BaseAbstractModalComponent, ModalCloseReason } from '../../../../../core/modal';
import { ShoppingListFacade } from '../../../../../core/user';

export interface DeleteShoppingListModalData {
  shoppingListCode: string;
  shoppingListName: string;
  redirectOnDeletion: boolean;
}
@Component({
  selector: 'py-delete-shopping-list-modal',
  templateUrl: './delete-shopping-list-modal.component.html',
  styleUrls: ['./delete-shopping-list-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DeleteShoppingListModalComponent extends BaseAbstractModalComponent implements OnInit, OnDestroy {
  shoppingListCode: string;
  shoppingListName: string;
  redirectOnDeletion: boolean = false;

  loading$: Observable<boolean>;
  error$: Observable<boolean>;

  private subscriptions = new Subscription();

  constructor(
    private shoppingListService: ShoppingListFacade,
    private routingService: RoutingService,
    protected launchDialogService: LaunchDialogService,
    protected el: ElementRef,
    protected renderer: Renderer2
  ) {
    super(el, launchDialogService, renderer);
  }

  ngOnInit(): void {
    this.shoppingListService.resetDeleteShoppingListState();
    this.loading$ = this.shoppingListService.deleteShoppingListLoading();
    this.error$ = this.shoppingListService.deleteShoppingListError().pipe(map(Boolean));

    this.subscriptions.add(
      this.launchDialogService.data$.pipe(take(1)).subscribe((data: DeleteShoppingListModalData) => {
        this.shoppingListCode = data.shoppingListCode;
        this.shoppingListName = data.shoppingListName;
        this.redirectOnDeletion = data.redirectOnDeletion;
      })
    );

    this.subscriptions.add(
      this.shoppingListService
        .deleteShoppingListSuccess()
        .pipe(
          filter((success) => success),
          take(1)
        )
        .subscribe(() => {
          this.launchDialogService.closeDialog(ModalCloseReason.DELETE_SHOPPING_LIST_SUCCESS);
        })
    );
  }

  onDelete(): void {
    if (this.redirectOnDeletion) {
      this.routingService.go({ cxRoute: 'shoppingLists' });
    }
    this.shoppingListService.resetDeleteShoppingListState();
    this.shoppingListService.deleteShoppingList(this.shoppingListCode);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
